import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { logProgramChange } from '@shoflo/studio-redux/utils';

import { setProgram } from 'actions/Broadcast';
import { sceneBuilder } from '@studio/program/sceneBuilder/sceneBuilder';
import {
  BROADCAST_CREATE_BANNER,
  BROADCAST_UPDATE_BANNER,
  BROADCAST_DELETE_BANNER,
  BROADCAST_TOGGLE_BANNER_HIDDEN,
  BROADCAST_DUPLICATE_BANNER,
  BROADCAST_UPDATE_SCENE_LAYERS
} from 'actions/Types';
import {
  attachAudioPresenterSources,
  getProgramLayers
} from 'utils/broadcastSourceHelper';

export const programSceneLayerUpdater = store => next => async action => {
  const { dispatch, getState } = store;

  const targetdActions = [
    `${BROADCAST_CREATE_BANNER}_SUCCESS`,
    `${BROADCAST_UPDATE_BANNER}_SUCCESS`,
    `${BROADCAST_DELETE_BANNER}_SUCCESS`,
    `${BROADCAST_TOGGLE_BANNER_HIDDEN}_SUCCESS`,
    `${BROADCAST_DUPLICATE_BANNER}_SUCCESS`,
    `${BROADCAST_UPDATE_SCENE_LAYERS}_SUCCESS`
  ];

  from([action])
    .pipe(filter($action => targetdActions.includes($action.type)))
    .subscribe(action => {
      const {
        banners,
        sceneLayers,
        sceneLayout,
        attendeeMuteStatus,
        program,
        backgrounds,
        broadcastSources: { sources },
        brandingSettings
      } = getState();

      const updatedSceneLayers =
        action.type === `${BROADCAST_UPDATE_SCENE_LAYERS}_SUCCESS`
          ? action.payload
          : sceneLayers;

      const updatedBanners = action.type.includes('BANNER')
        ? action.payload
        : banners;

      const combinedLayers = [...updatedSceneLayers, ...updatedBanners];
      let currentSources =
        (program &&
          getProgramLayers(program)
            .filter(ls => sources.find(s => s._id === ls.source._id))
            .map(ls => ls.source)) ||
        [];

      const withAudioPresenterSources = attachAudioPresenterSources(
        currentSources,
        attendeeMuteStatus
      );

      const scene = sceneBuilder(
        sceneLayout,
        withAudioPresenterSources,
        combinedLayers,
        {},
        {},
        brandingSettings?.fonts
      );

      const currentBackground = backgrounds.find(
        b => b._id === program?.style?.backgroundId && b.source.hidden === false
      );

      dispatch(
        setProgram(
          {
            ...scene,
            style: currentBackground ? program.style : scene.style
          },
          action.isTransient,
          { updatedSceneLayers }
        )
      );
      logProgramChange(getState, 'programSceneLayerUpdater middleware');
    });

  return next(action);
};

export default programSceneLayerUpdater;
